<snelstart-ui-dialog-definition id="id" title="Validatiemeldingen" size="lg" [(visible)]="this.dialogVisible">
  <snelstart-ui-dialog-header-content>Validatiemeldingen geven aan of er onjuistheden zijn aangetroffen.
    Zolang hier onopgeloste validatiemeldingen staan, kan er niet succesvol gerekend of verzonden worden.
  </snelstart-ui-dialog-header-content>

  <snelstart-ui-dialog-body>

    @if (this.validaties === 0) {
      @if (this.showSpinner) {
        <snelstart-ui-spinner></snelstart-ui-spinner>
      } @else {
        <snelstart-ui-alert type="success">
          Er zijn geen validatiemeldingen.
        </snelstart-ui-alert>
      }
    } @else {
      <div class="accordion" id="accordionExample">
        @for (item of validatieList; track $index) {
          <div class="accordion-item">
            <h2 class="accordion-header" id="heading{{$index}}">
              <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                [attr.data-bs-target]="'#collapse' + $index"
                [attr.aria-expanded]="validatieList.length === 1 ? 'true' : 'false'"
                [attr.aria-controls]="'collapse' + $index"
                [class.collapsed]="validatieList.length !== 1">
                {{ $index + 1 }}. {{ item.error || 'Algemene validatiemelding' }}
              </button>
            </h2>
            <div
              id="collapse{{$index}}"
              class="accordion-collapse collapse"
              [attr.aria-labelledby]="'heading' + $index"
              [class.show]="validatieList.length === 1"
              [attr.data-bs-parent]="validatieList.length > 1 ? '#accordionExample' : null">
              <div class="accordion-body">
                <p class="bevinding">{{ item.message || 'Geen extra details beschikbaar.' }}</p>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button id="save" type="primary" btn-x
                         (click)="this.dialogVisibleChange.emit(false)">Akkoord
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>

</snelstart-ui-dialog-definition>
